import { EditBuildingFormState } from '../model/types'
import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { generateTranslationSchema } from '@/shared/lib/generateTranslationSchema'
import { defaultTranslationsEdit } from '@/entities/ContentTranslation/lib/translationDefaults'
import { LanguageTabConfig } from '@/features/MultilingualTabs/model/types'
import { ModelsType2 as Type, ParkingType } from '@/shared/api/topli/TopliApi'

export const editBuildingFormDefault: EditBuildingFormState = {
  id: 0,
  activity: false,
  checked_manual: true,
  polygon: [],
  delivery_date: '',
  done: false,
  hide_price: false,
  area: 0,
  unitcount: 0,
  car_unitcount: 0,
  type: [],
  parking_type: null,
  nol: 0,
  residential_id: 0,
  address_id: 0,
  has_ai_translation: false,
  translations: defaultTranslationsEdit,
  emlak_id: null,
  emlak_code: null,
}

export const editBuildingFormSchema = (t: TFunction, languageTabs: LanguageTabConfig[]) => {
  return Yup.object().shape({
    activity: Yup.boolean(),
    checked_manual: Yup.boolean(),
    done: Yup.boolean().nullable(),
    hide_price: Yup.boolean().nullable(),
    residential_id: Yup.number()
      .min(1, t('common:validation_messages.required'))
      .required(t('common:validation_messages.required')),
    area: Yup.number().min(-2147483648).max(2147483647),
    polygon: Yup.array(Yup.array(Yup.number())).nullable(),
    unitcount: Yup.number()
      .min(0, t('common:validation_messages.min', { count: 0 }))
      .nullable(),
    car_unitcount: Yup.number().nullable(),
    type: Yup.array()
      .of(
        Yup.mixed()
          .oneOf(Object.values(Type) as number[], t('common:validation_messages.required'))
          .required(t('common:validation_messages.required')),
      )
      .ensure()
      .min(1, t('common:validation_messages.required')),
    parking_type: Yup.mixed()
      .oneOf(Object.values(ParkingType) as number[], t('common:validation_messages.required'))
      .nullable(),
    nol: Yup.number()
      .min(0, t('common:validation_messages.min', { count: 0 }))
      .required(t('common:validation_messages.required')),
    delivery_date: Yup.date().nullable(),
    ...generateTranslationSchema(languageTabs, t, true).fields,
  })
}
